import { lazy } from "react";
import { Navigate } from "react-router-dom";
import PublicRouteContainer from "./PublicRouteContainer";
import { REDIRECT_TO_MAIN_PAGE } from "settings/menu/dashboardsPages";

const Login = lazy(() => import("../pages/Login/Login"));
const Logout = lazy(() => import("../pages/Logout/Logout"));
const Unauthorized = lazy(() => import("../pages/ServicePages/Unauthorized"));
const Unavailable = lazy(() => import("../pages/ServicePages/Unavailable"));
const Expired = lazy(() => import("../pages/ServicePages/Expired"));

const publicRoutes = [
  { path: "/", element: <Navigate to={REDIRECT_TO_MAIN_PAGE} /> },
  {
    element: <PublicRouteContainer />,
    children: [
      {
        path: "/login",
        element: <Login />,
        errorElement: <Unavailable />,
      },
      {
        path: "/logout",
        element: <Logout />,
      },
      {
        path: "/forbidden",
        element: <Unauthorized />,
      },
      {
        path: "/unavailable",
        element: <Unavailable />,
      },
      {
        path: "/subscription-expired",
        element: <Expired />,
        errorElement: <Unavailable />,
      },
    ],
  },
];

export default publicRoutes;
